import styled from 'styled-components';
import Colors from 'assets/Colors';

const Container = styled.div`
  width: 100%;
  border-radius: 6px;
  padding: 26px 20px 0px 19px;
  max-width: 100vw;
  margin-bottom: 36px;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
  overflow: hidden;
`;

const TopElementContainer = styled.div`
  background: ${Colors.BG_Header_Card};
  height: 42px;
  color: ${Colors.text_on_primary};
  margin: -26px -20px 0px -19px;
  padding: 0px 20px 0px 19px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0px;
`;

const LastDaysText = styled.div`
  font-style: normal;
  font-weight: 300;
  font-size: 10px;
  line-height: 18px;
`;

const Title = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0.01em;
`;

const ListWrapper = styled.div`
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  // padding-right: 22px;
`;

const Separator = styled.hr`
  margin: 0;
  border: 0;
  border-top: 1px solid ${Colors.line_separator};
  padding: 0;
`;

const ListText = styled.div`
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 21px;
  color: ${Colors.text_primary};
`;

const ListTextBold = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
  color: ${Colors.text_primary};
  text-align: right;
`;

const ListRightElements = styled.div`
  display: flex;
  align-items: center;
  margin-left: 10px;
`;

const BottomText = styled.div`
  color: ${Colors.text_secondary};
  font-style: normal;
  font-weight: 300;
  font-size: 10px;
  line-height: 18px;
  text-align: end;
  margin-top: 15px;
`;

export default {
  Container,
  TopElementContainer,
  LastDaysText,
  Title,
  ListWrapper,
  Separator,
  ListText,
  ListTextBold,
  ListRightElements,
  BottomText,
};
